/*
 * Copyright (C) [2025] [Netzint GmbH]
 * All rights reserved.
 *
 * This software is dual-licensed under the terms of:
 *
 * 1. The GNU Affero General Public License (AGPL-3.0-or-later), as published by the Free Software Foundation.
 *    You may use, modify and distribute this software under the terms of the AGPL, provided that you comply with its conditions.
 *
 *    A copy of the license can be found at: https://www.gnu.org/licenses/agpl-3.0.html
 *
 * OR
 *
 * 2. A commercial license agreement with Netzint GmbH. Licensees holding a valid commercial license from Netzint GmbH
 *    may use this software in accordance with the terms contained in such written agreement, without the obligations imposed by the AGPL.
 *
 * If you are uncertain which license applies to your use case, please contact us at info@netzint.de for clarification.
 */

import { motion } from 'framer-motion';
import cn from '../utils/cn';

interface CircleLoaderProps {
  className?: string;
  transitionDurationMS?: number;
  height?: string;
  width?: string;
  forceLightMode?: boolean;
}

const CircleLoader = ({
  className,
  transitionDurationMS = 1000,
  height = 'h-12',
  width = 'w-12',
  forceLightMode = false,
}: CircleLoaderProps) => (
  <div className={cn('relative box-border', height, width, className)}>
    <motion.span
      className={cn(
        'absolute left-0 top-0 z-30 box-border block rounded-full border-4 border-t-4',
        forceLightMode ? 'border-lightGrey border-t-primary' : 'border-accent border-t-primary',
        height,
        width,
      )}
      animate={{ rotate: 360 }}
      transition={{
        loop: Infinity,
        ease: 'linear',
        duration: transitionDurationMS,
      }}
      style={{
        animation: `spin ${transitionDurationMS / 1000}s linear infinite`,
      }}
    />
  </div>
);

export default CircleLoader;
export type { CircleLoaderProps };
